module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade",
    attrs: {
      "id": "modalCreateMembers"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.group && _vm.group.name) + " : " + _vm._s(_vm.$t("groups.createMembersModal.title")))])]), (_vm.group && _vm.group.members && !_vm.group.members.canEditMembers) ? [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t("groups.createMembersModal.noSuffisantRight")))])])] : [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.savingState == null) ? [(this.firstSelectedGroop) ? [(this.firstSelectedGroop.autoInscription && this.firstSelectedGroop.autoInscription.method) ? [_c('auto-inscription', {
    attrs: {
      "groop": _vm.firstSelectedGroop
    }
  }), _c('div', {
    staticClass: "text-center text-muted"
  }, [_c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": _vm.goToManagement
    }
  }, [_vm._v(_vm._s(_vm.$t("groups.createMembersModal.changeAutoInscription")))])])] : [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.$t('groups.createMembersModal.wantToTryAutoInscription'))), _c('div', {
    staticClass: "text-center text-muted"
  }, [_c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": _vm.goToManagement
    }
  }, [_vm._v(_vm._s(_vm.$t("groups.createMembersModal.changeAutoInscription")))])])])], (this.firstSelectedGroop.autoInscription && this.firstSelectedGroop.autoInscription.method) ? [_c('hr'), _c('h4', [_vm._v(_vm._s(_vm.$t("groups.createMembersModal.subtitle")))])] : _vm._e(), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [(_vm.onBatchMembers) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("groups.createMembersModal.fields.emails.label")))]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emails),
      expression: "emails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.$t("groups.createMembersModal.fields.emails.placeholder"),
      "rows": "10"
    },
    domProps: {
      "value": (_vm.emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emails = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t("groups.createMembersModal.fields.emailsRole.label")))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailsRole),
      expression: "emailsRole"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.emailsRole = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "value": role
      }
    }, [_vm._v(_vm._s(_vm.$t("groupManagement.roles." + role)))])
  }), 0), _c('p', {
    staticClass: "help-block"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t("groupManagement.roles.explanation." + _vm.emailsRole)))])])])] : _vm._e(), (_vm.onFineMembers) ? [_vm._l((_vm.members), function(m) {
    return _c('div', {
      staticClass: "form-group memberLine"
    }, [_c('i', {
      staticClass: "fa fa-times-circle removeBtn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.remove(m)
        }
      }
    }), (m.id) ? [_c('div', {
      staticClass: "col-sm-9"
    }, [_c('vue-object-img', {
      staticClass: "fine",
      attrs: {
        "object": m
      }
    }), _vm._v(" " + _vm._s(m.name))], 1)] : [_c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (m.name),
        expression: "m.name"
      }],
      staticClass: "form-control text",
      attrs: {
        "required": "required",
        "placeholder": _vm.$t("groups.createMembersModal.fields.member.name.placeholder")
      },
      domProps: {
        "value": (m.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(m, "name", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-sm-5"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (m.email),
        expression: "m.email"
      }],
      staticClass: "form-control text",
      attrs: {
        "type": "email",
        "placeholder": _vm.$t("groups.createMembersModal.fields.member.email.placeholder")
      },
      domProps: {
        "value": (m.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(m, "email", $event.target.value)
        }
      }
    })])], _c('div', {
      staticClass: "col-sm-3"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (m.role),
        expression: "m.role"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(m, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.roles), function(role) {
      return _c('option', {
        domProps: {
          "value": role
        }
      }, [_vm._v(_vm._s(_vm.$t("groupManagement.roles." + role)))])
    }), 0)])], 2)
  }), _c('auto-complete-user', {
    ref: "autoCompleteUser",
    attrs: {
      "showGroops": "mine",
      "showUsers": "all",
      "placeholder": _vm.$t("groups.createMembersModal.fields.nameField.placeholder"),
      "acceptNewUser": true,
      "acceptNewGroop": false,
      "container": _vm.$refs.modal.getElementsByClassName("modal-body")[0]
    },
    on: {
      "select": _vm.addUserFromAutocomplete
    }
  })] : _vm._e(), (_vm.onEditInvitationText) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("groups.createMembersModal.fields.invitationText.label")))]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invitationText),
      expression: "invitationText"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.$t("groups.createMembersModal.fields.invitationText.placeholder"),
      "rows": "10"
    },
    domProps: {
      "value": (_vm.invitationText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invitationText = $event.target.value
      }
    }
  })])])] : _vm._e()], 2)] : _vm._e()] : _vm._e(), (_vm.savingState == "saving") ? _c('div', {
    staticClass: "bigIconMessage"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin grey"
  }), _vm._v(" " + _vm._s(_vm.$t("globals.sending")))]) : _vm._e(), (_vm.savingState == "saved") ? _c('div', {
    staticClass: "bigIconMessage"
  }, [_c('i', {
    staticClass: "fa fa-check green"
  }), _vm._v(" " + _vm._s(_vm.$t("globals.created")))]) : _vm._e(), (_vm.savingState == "error") ? _c('div', {
    staticClass: "bigIconMessage"
  }, [_c('i', {
    staticClass: "fa fa-remove red"
  }), _vm._v(" " + _vm._s(_vm.$t("globals.error")))]) : _vm._e()], 2), (_vm.savingState == null) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.onEditInvitationText) ? _c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [(_vm.onFineMembers || _vm.onEditInvitationText) ? [_vm._v(_vm._s(_vm.$t('globals.previous')))] : _vm._e(), (_vm.onBatchMembers) ? [_vm._v(_vm._s(_vm.$t('globals.cancel')))] : _vm._e()], 2) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      disabled: !_vm.mustHaveIsComplete
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createMembers
    }
  }, [(_vm.onEditInvitationText) ? [_vm._v(_vm._s(_vm.$t('globals.create')))] : _vm._e(), (_vm.onBatchMembers || _vm.onFineMembers) ? [_vm._v(_vm._s(_vm.$t('globals.next')))] : _vm._e()], 2)]) : _vm._e()]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eee62c3","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupManagement/NewMembers.vue
// module id = 1247
// module chunks = 1